export const homeTranslations = {
  // Not Found
  notfound_title: 'This page has not been generated',
  notfound_desc: 'Tell me more about this page, so I can generate it.',

  // Nav
  nav_home: 'Home',
  nav_services: 'Services',
  nav_gallery: 'Gallery',
  nav_areas: 'Service Areas',
  nav_reviews: 'Reviews',
  nav_contact: 'Contact',
  nav_cta: 'Request a Free Quote',
  lang_english: 'English',
  lang_spanish: 'Español',

  // Hero
  hero_tag: 'PROFESSIONAL SERVICE',
  hero_title: 'House Cleaning',
  hero_subtitle: 'Experience a spotless home with our thorough residential cleaning services tailored to your needs.',
  hero_cta_primary: 'Get Free Estimate',
  hero_cta_secondary: 'View Services',

  // Services
  services_label: 'OUR SERVICES',
  services_title: 'Premium Cleaning Solutions for Every Space',
  services_learn_more: 'Learn More',

  // Slides
  slide_2_tag: 'TRUSTED EXPERTS',
  slide_2_title: 'Apartment Cleaning',
  slide_2_subtitle: 'Compact spaces deserve big results. Our apartment cleaning delivers perfection in every corner.',
  slide_3_tag: 'COMMERCIAL GRADE',
  slide_3_title: 'Office Cleaning',
  slide_3_subtitle: 'Keep your workspace pristine and productive with our reliable commercial cleaning solutions.',
  slide_4_tag: 'SPECIALIZED CLEANUP',
  slide_4_title: 'Post-Construction Cleaning',
  slide_4_subtitle: 'Transform dusty construction sites into move-in ready spaces with our specialized cleanup crews.',
  slide_5_tag: 'MOVE WITH EASE',
  slide_5_title: 'Move-In / Move-Out Cleaning',
  slide_5_subtitle: 'Start fresh in your new space or leave your old one immaculate with our move cleaning services.',

  // About
  about_label: 'ABOUT US',
  about_title: 'Why Families & Businesses Trust Us',
  about_description:
    'We deliver residential, apartment, office, and post-construction cleaning with a trained team and flexible scheduling. Choose one-time or recurring contracts — we adapt to your needs.',

  // Service Areas
  areas_label: 'WHERE WE WORK',
  areas_title: 'Areas We Proudly Serve',
  areas_note:
    'Not sure if we cover your area? Reach out and we will be happy to assist.',
  areas_no_data: 'No service areas available',
  areas_add_hint: 'Service areas will appear here once added.',

  // Gallery
  gallery_label: 'OUR WORK',
  gallery_title: 'Before & After Gallery',
  gallery_upload: 'Upload / Change Image',
  gallery_no_data: 'No gallery images yet',
  gallery_add_hint: 'Images will appear here once added.',

  // Facebook
  facebook_label: 'SOCIAL',
  facebook_title: 'Follow Us on Facebook',
  facebook_placeholder_title: 'Facebook Feed',
  facebook_placeholder_desc:
    'Facebook feed integration will be connected from the admin settings.',
  facebook_follow: 'Follow on Facebook',

  // Reviews
  reviews_label: 'TESTIMONIALS',
  reviews_title: 'What Our Clients Say',

  // Contact
  contact_label: 'GET IN TOUCH',
  contact_title: 'Request a Free Quote',
  contact_subtitle: 'Fill out the form below and we will get back to you within 24 hours.',
  contact_info_title: 'Contact Information',
  contact_phone_label: 'Phone',
  contact_email_label: 'Email',
  contact_address_label: 'Office',
  contact_hours_label: 'Hours',
  contact_cta_title: 'Need a Quick Answer?',
  contact_cta_desc: 'Call us directly for immediate assistance with your cleaning needs.',
  contact_call_now: 'Call Now',
  form_fullName: 'Full Name',
  form_fullName_placeholder: 'John Doe',
  form_phone: 'Phone',
  form_phone_placeholder: '(555) 000-0000',
  form_email: 'Email',
  form_email_placeholder: 'john@example.com',
  form_serviceType: 'Service Type',
  form_serviceType_placeholder: 'Select a service...',
  form_address: 'Property Address',
  form_address_placeholder: '123 Main St, City, CA',
  form_date: 'Preferred Date',
  form_message: 'Message',
  form_message_placeholder: 'Tell us more about your cleaning needs...',
  form_submit: 'Send Request',
  form_required: 'Missing Information',
  form_required_msg: 'Please fill in all required fields (Name, Phone, Email, Service Type).',
  form_success: 'Thank you for contacting us!',
  form_success_body: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',
  form_error: 'Error',
  form_error_msg: 'Something went wrong. Please try again.',

  // Footer
  footer_company: 'Complete Home Care Cleaning',
  footer_desc: 'Professional residential and commercial cleaning services across the North Bay Area. Quality you can trust.',
  footer_links: 'Quick Links',
  footer_areas: 'Service Areas',
  footer_social: 'Follow Us',
  footer_hours: 'Mon – Sat: 8AM – 6PM',
  footer_copyright: '\u00a9 2026 Complete Home Care Cleaning. All rights reserved.',
  footer_made_with: 'Made with care for clean homes.',

  // Admin
  admin_dashboard: 'Dashboard',
  admin_hero_slider: 'Hero Slider',
  admin_services: 'Services',
  admin_gallery: 'Gallery',
  admin_service_areas: 'Service Areas',
  admin_page_content: 'Page Content',
  admin_facebook: 'Facebook Feed',
  admin_messages: 'Messages',
  admin_settings: 'Settings',
  admin_website_admin: 'Website Admin',
  admin_complete_home: 'Complete Home Care',
  admin_manage: 'Manage',
  admin_system: 'System',
  admin_back_website: 'Back to site',
  admin_administrator: 'Administrator',
  admin_total_services: 'Total Services',
  admin_gallery_images: 'Gallery Images',
  admin_service_areas_short: 'Service Areas',
  admin_new_messages: 'New Messages',
  admin_new_quotes: 'New Quotes',
  admin_new_appointments: 'New Appointments',
  admin_new_ai_leads: 'AI Leads',
  admin_active_services: 'Active services',
  admin_in_portfolio: 'In portfolio',
  admin_coverage_zones: 'Coverage zones',
  admin_pending_replies: 'Pending replies',
  admin_pending_quotes: 'Pending quotes',
  admin_pending_appointments: 'Pending appointments',
  admin_pending_ai_leads: 'AI assistant leads',
  admin_edit_hero: 'Edit Hero',
  admin_update_slider: 'Update slider images & text',
  admin_add_service: 'Add Service',
  admin_create_service: 'Create new service offering',
  admin_upload_image: 'Upload Image',
  admin_add_gallery: 'Add to gallery portfolio',
  admin_view_messages: 'View Messages',
  admin_check_quotes: 'Check quote requests',
  admin_recent_messages: 'Recent Messages',
  admin_recent_activity: 'Recent Activity',
  admin_view_all: 'View All',
  admin_backend_notice: 'Backend Not Connected',
  admin_backend_desc: 'Backend API connection will be enabled after PHP/MySQL integration.',
  admin_saved: 'Saved successfully',
  admin_saved_local: 'saved successfully (local only — backend needed for persistence).',
  admin_delete: 'Delete',
  admin_delete_confirm: 'This action cannot be undone.',
  admin_deleted: 'Deleted',
  admin_deleted_local: 'removed (local only).',
  admin_cancel: 'Cancel',
  admin_save_changes: 'Save Changes',
  admin_add: 'Add',
  admin_edit: 'Edit',
  admin_close: 'Close',
  admin_coming_soon: 'Coming Soon',
  admin_requires_backend: 'This feature requires backend integration.',
  admin_upload_image_title: 'Upload Image',
  admin_upload_backend: 'Image upload requires backend integration.',
  admin_active: 'Active',
  admin_inactive: 'Inactive',
  admin_visible: 'Visible on website',
  admin_hidden: 'Hidden from website',
  admin_changes_local: 'Changes are saved locally only',
  admin_field_saved: 'Field Saved',
  admin_content_updated: 'Content updated successfully.',
  admin_all_saved: 'All Changes Saved',
  admin_reset_confirm: 'This will revert all fields to their default values.',
  admin_reset_complete: 'Reset Complete',
  admin_settings_saved: 'Settings Saved',
  admin_business_info: 'Business Information',
  admin_social_media: 'Social Media Links',
  admin_business_hours: 'Business Hours',
  admin_company_name: 'Company Name',
  admin_phone_number: 'Phone Number',
  admin_email_address: 'Email Address',
  admin_business_address: 'Business Address',
  admin_facebook_url: 'Facebook URL',
  admin_instagram_url: 'Instagram URL',
  admin_yelp_url: 'Yelp URL',
  admin_weekday_hours: 'Weekday Hours',
  admin_weekend_hours: 'Weekend Hours',
  admin_timezone: 'Timezone',
  admin_tip: 'Tip',
  admin_settings_tip: 'These settings will be displayed on your public website footer and contact section.',
  admin_hero_manager: 'Hero Slider Manager',
  admin_manage_hero: 'Manage your website content, services, gallery and messages.',
  admin_add_slide: 'Add Slide',
  admin_slide_tag: 'Tag',
  admin_slide_order: 'Display Order',
  admin_slide_title: 'Slide Title',
  admin_slide_subtitle: 'Subtitle / Description',
  admin_primary_btn: 'Primary Button Text',
  admin_secondary_btn: 'Secondary Button Text',
  admin_save_slide: 'Save Slide',
  admin_preview_image: 'Preview Image',
  admin_change_image: 'Change Image',
  admin_services_manager: 'Services Manager',
  admin_manage_services: 'Manage your service offerings',
  admin_add_service_btn: 'Add Service',
  admin_service_title: 'Service Title',
  admin_short_desc: 'Short Description',
  admin_full_desc: 'Full Description',
  admin_shown_cards: 'Shown on service cards and listings',
  admin_shown_detail: 'Shown on service detail views',
  admin_save_service: 'Save Service',
  admin_icon: 'Icon',
  admin_gallery_manager: 'Gallery Manager',
  admin_manage_gallery: 'Manage your portfolio images',
  admin_add_image: 'Add Image',
  admin_image_title: 'Image Title',
  admin_category: 'Category',
  admin_alt_text: 'Alt Text',
  admin_alt_hint: 'Used for screen readers and SEO',
  admin_save_image: 'Save Image',
  admin_areas_manager: 'Service Areas Manager',
  admin_manage_areas: 'Manage your service coverage areas and locations',
  admin_add_area: 'Add Area',
  admin_city_name: 'City / Area Name',
  admin_state: 'State',
  admin_display_order: 'Display Order',
  admin_area_updated: 'Area Updated',
  admin_area_added: 'Area Added',
  admin_area_saved: 'has been saved (local only).',
  admin_remove_area: 'Are you sure you want to remove',
  admin_content_manager: 'Page Content Manager',
  admin_edit_content: 'Edit your website text, contact info, and key messaging',
  admin_unsaved: 'Unsaved changes',
  admin_save_all: 'Save All Changes',
  admin_reset_defaults: 'Reset to Defaults',
  admin_content_hint: 'Displayed in header, footer, and meta tags.',
  admin_phone_hint: 'Shown in header, contact section, and footer.',
  admin_email_hint: 'Contact email displayed on the website.',
  admin_hero_cta_hint: 'Primary button text on the hero slider.',
  admin_about_title_hint: 'Heading displayed above the about section.',
  admin_about_text_hint: 'Main paragraph displayed in the about section.',
  admin_footer_hint: 'Short text shown in the footer above copyright.',
  admin_facebook_settings: 'Facebook Feed Settings',
  admin_facebook_desc: 'Configure your Facebook page integration and feed display',
  admin_facebook_url: 'Facebook Page URL',
  admin_embed_code: 'Facebook Feed Embed Code',
  admin_embed_hint: 'Paste the embed code from Facebook Page Plugin.',
  admin_facebook_help: 'How to get your embed code',
  admin_facebook_help_desc: 'Visit Facebook Page Plugin to generate your embed code.',
  admin_contact_messages: 'Contact Messages',
  admin_view_manage: 'View and manage incoming quote requests',
  admin_new_count: 'New',
  admin_contacted_count: 'Contacted',
  admin_resolved_count: 'Resolved',
  admin_name: 'Name',
  admin_phone: 'Phone',
  admin_email: 'Email',
  admin_service_type: 'Service Type',
  admin_preferred_date: 'Preferred Date',
  admin_status: 'Status',
  admin_created_at: 'Created At',
  admin_actions: 'Actions',
  admin_no_messages: 'No messages found',
  admin_property_address: 'Property Address',
  admin_received: 'Received',
  admin_send_email: 'Send Email',
  admin_send_whatsapp: 'Send WhatsApp',
  admin_mark_contacted: 'Mark as Contacted',
  admin_mark_resolved: 'Mark as Resolved',
  admin_archive: 'Archive',
  admin_archived: 'Archived',
  admin_archive_confirm: 'Are you sure you want to archive this message? It will be removed from the active list.',
  admin_status_update_error: 'Failed to update status. Please try again.',
  admin_archive_error: 'Failed to archive. Please try again.',
  admin_status_updated: 'Status changed to',
  admin_no_content: 'No content set',
  admin_of_active: 'active',
  admin_status_new: 'New',
  admin_status_contacted: 'Contacted',
  admin_status_resolved: 'Resolved',
  admin_status_reviewing: 'Reviewing',
  admin_status_quoted: 'Quoted',
  admin_status_won: 'Won',
  admin_status_lost: 'Lost',
  admin_status_archived: 'Archived',
  admin_status_scheduled: 'Scheduled',
  admin_status_completed: 'Completed',
  admin_status_cancelled: 'Cancelled',
  admin_preferred_time: 'Preferred Time',
  admin_no_contacted_messages: 'No contacted messages.',

  // Admin Message Tabs
  admin_tab_contact: 'Contact Messages',
  admin_tab_quotes: 'Quote Requests',
  admin_tab_appointments: 'Appointments',
  admin_tab_ai_leads: 'AI Leads',
  admin_loading: 'Loading...',
  admin_empty: 'No records found',
  admin_refresh: 'Refresh',
  admin_no_quotes: 'No quote requests found.',
  admin_no_appointments: 'No appointments found.',
  admin_no_ai_leads: 'No AI leads found.',
  admin_appointment_type: 'Appointment Type',
  admin_property_type: 'Property Type',
  admin_budget: 'Budget',
  admin_extras: 'Extras',
  admin_square_feet: 'Square Feet',
  admin_bedrooms: 'Bedrooms',
  admin_bathrooms: 'Bathrooms',
  admin_source: 'Source',
  admin_cleaning_type: 'Cleaning Type',
  admin_frequency: 'Frequency',
  admin_kitchens: 'Kitchens',
  admin_living_rooms: 'Living Rooms',
  admin_dining_rooms: 'Dining Rooms',
  admin_offices: 'Offices',
  admin_garage: 'Garage',
  admin_incoming_quotes: 'Incoming quote requests will appear here.',
  admin_incoming_appointments: 'Incoming appointments will appear here.',
  admin_incoming_ai_leads: 'AI assistant leads will appear here.',
  admin_ai_assistant: 'AI Assistant',

  // Form
  form_sending: 'Sending...',
  form_thanks: 'Great, thanks!',

  // Detailed Quote Modal
  quote_cta: 'Get Detailed Quote',
  quote_modal_title: 'Get Your Detailed Quote',
  quote_modal_subtitle: 'Tell us about your property and we will send you a customized estimate within 24 hours.',
  quote_fullName: 'Full Name',
  quote_fullName_placeholder: 'John Doe',
  quote_phone: 'Phone',
  quote_phone_placeholder: '(555) 000-0000',
  quote_email: 'Email',
  quote_email_placeholder: 'john@example.com',
  quote_address: 'Property Address',
  quote_address_placeholder: '123 Main St, City, CA',
  quote_propertyType: 'Property Type',
  quote_propertyType_placeholder: 'Select property type...',
  quote_propertyType_house: 'House',
  quote_propertyType_apartment: 'Apartment',
  quote_propertyType_office: 'Office',
  quote_propertyType_commercial: 'Commercial',
  quote_propertyType_post_construction: 'Post-Construction',
  quote_propertyType_move_in_out: 'Move-In / Move-Out',
  quote_propertyType_other: 'Other',
  quote_bedrooms: 'Bedrooms',
  quote_bedrooms_placeholder: 'e.g., 3',
  quote_bathrooms: 'Bathrooms',
  quote_bathrooms_placeholder: 'e.g., 2',
  quote_kitchens: 'Kitchens',
  quote_kitchens_placeholder: 'e.g., 1',
  quote_livingRooms: 'Living Rooms',
  quote_livingRooms_placeholder: 'e.g., 1',
  quote_diningRooms: 'Dining Rooms',
  quote_diningRooms_placeholder: 'e.g., 1',
  quote_offices: 'Offices',
  quote_offices_placeholder: 'e.g., 0',
  quote_garage: 'Garage',
  quote_garage_none: 'None',
  quote_garage_1: '1 Car',
  quote_garage_2: '2 Cars',
  quote_garage_3plus: '3+ Cars',
  quote_garage_other: 'Other',
  quote_squareFeet: 'Square Feet',
  quote_squareFeet_placeholder: 'e.g., 2,500',
  quote_frequency: 'Cleaning Frequency',
  quote_frequency_placeholder: 'Select frequency...',
  quote_frequency_onetime: 'One-Time',
  quote_frequency_weekly: 'Weekly',
  quote_frequency_biweekly: 'Biweekly',
  quote_frequency_monthly: 'Monthly',
  quote_frequency_contract: 'Contract',
  quote_frequency_event: 'Event',
  quote_frequency_other: 'Other',
  quote_cleaningType: 'Cleaning Type',
  quote_cleaningType_placeholder: 'Select cleaning type...',
  quote_cleaningType_standard: 'Standard',
  quote_cleaningType_deep: 'Deep Cleaning',
  quote_cleaningType_post_construction: 'Post-Construction',
  quote_cleaningType_move_in_out: 'Move-In / Move-Out',
  quote_cleaningType_office: 'Office',
  quote_cleaningType_event: 'Event',
  quote_cleaningType_other: 'Other',
  quote_extras: 'Extras',
  quote_extras_windows: 'Windows',
  quote_extras_oven: 'Inside Oven',
  quote_extras_fridge: 'Inside Refrigerator',
  quote_extras_cabinets: 'Cabinets',
  quote_extras_baseboards: 'Baseboards',
  quote_extras_laundry: 'Laundry',
  quote_extras_dishes: 'Dishes',
  quote_extras_carpet: 'Carpet Vacuum',
  quote_extras_garage: 'Garage Cleaning',
  quote_extras_patio: 'Patio',
  quote_date: 'Preferred Date',
  quote_time: 'Preferred Time',
  quote_time_placeholder: 'e.g., 10:00 AM',
  quote_budget: 'Budget Range',
  quote_budget_placeholder: 'e.g., $150 \u2013 $300',
  quote_notes: 'Notes',
  quote_notes_placeholder: 'Any additional details...',
  quote_notes_max: 'characters',
  quote_submit: 'Submit Quote Request',
  quote_submitting: 'Submitting...',
  quote_required: 'Missing Information',
  quote_required_msg: 'Please fill in all required fields (Name, Phone, Email, Property Type).',
  quote_city: 'City',
  quote_city_placeholder: 'e.g., Santa Rosa',
  quote_success: 'Thank you for contacting us!',
  quote_success_body: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',
  quote_error: 'Error',
  quote_error_msg: 'Something went wrong. Please try again.',
  quote_close: 'Close',

  // AI Booking Widget
  ai_widget_btn: 'Need Help Scheduling?',
  ai_widget_title: 'Scheduling Assistant',
  ai_widget_subtitle: 'We help you book the perfect appointment',
  ai_tooltip: 'Need help booking?',
  ai_welcome_msg: 'Hello, please, you can call the number 7076236359 for an estimate. Thank you Hello, thank you for contacting complet care Home cleaning through this page. From which city are you contacting us? We work with counties Marin Napa Sonoma and Lake Kanyon we specialize in cleaning services, from deep cleaning to light cleaning in homes, offices, restaurants, and wynery bars. Can you send me the square feet of the property please. Thank you',
  ai_step1_msg: 'Would you like a phone call or an in-person estimate?',
  ai_phone_call: 'Phone Call',
  ai_in_person: 'In-Person Estimate',
  ai_step2_phone_msg: 'Please leave your name, phone number, preferred date and time, and service type. We will call you back to give you an estimate.',
  ai_step2_inperson_msg: 'Please leave your name, phone number, property address, preferred date and time, and service type. We will contact you to confirm your in-person estimate.',
  ai_step2_msg: 'Please leave your name, phone number, preferred date and time, and service type. We will call you back to give you an estimate.',
  ai_fullName: 'Full Name',
  ai_fullName_placeholder: 'John Doe',
  ai_phone: 'Phone',
  ai_phone_placeholder: '(555) 000-0000',
  ai_email: 'Email',
  ai_email_placeholder: 'john@example.com',
  ai_serviceType: 'Service Type',
  ai_serviceType_placeholder: 'Select a service...',
  ai_propertyAddress: 'Property Address',
  ai_propertyAddress_placeholder: '123 Main St, City, CA',
  ai_step3_msg: 'When would you prefer us to come by?',
  ai_preferredDate: 'Preferred Date',
  ai_preferredTime: 'Preferred Time',
  ai_preferredTime_placeholder: 'e.g., 10:00 AM',
  ai_notes: 'Additional Notes',
  ai_notes_placeholder: 'Any special instructions...',
  ai_back: 'Back',
  ai_continue: 'Continue',
  ai_schedule: 'Schedule Appointment',
  ai_typing: 'typing...',
  ai_success: 'Thank you for contacting us!',
  ai_success_body: 'Thank you. We received your request. We will contact you soon. For faster service, call (707) 623-6359.',
  ai_required_msg: 'Please fill in all required fields: Name, Phone, and Service Type.',
  ai_required_address_msg: 'Please enter the property address for the in-person estimate.',
  ai_error: 'Something went wrong',
  ai_error_body: 'Please try again or call us directly.',

  // Admin entities
  admin_slide: 'Slide',
  admin_image: 'Image',
  admin_service: 'Service',
  admin_saving: 'Saving...',
  admin_missing_info: 'Missing Information',
  admin_enter_city: 'Please enter the city or area name.',
  admin_enter_state: 'Please enter the state abbreviation.',
  admin_missing_url: 'Missing URL',
  admin_enter_facebook_url: 'Please enter your Facebook page URL.',
  admin_open_email_app: 'Open Email App',
  admin_open_whatsapp: 'Open WhatsApp',
  admin_saved_btn: 'Saved!',
  admin_total_areas: 'Total Areas',
  admin_active_short: 'Active',
  admin_inactive_short: 'Inactive',
  admin_states: 'States',
  admin_no_images: 'No images yet',
  admin_upload_images_desc: 'Upload images to build your gallery.',
  admin_no_service_areas: 'No service areas yet',
  admin_add_first_area: 'Add your first coverage area to get started.',
  admin_no_slides: 'No hero slides yet',
  admin_add_first_slide: 'Add your first slide to display on the homepage hero section.',
  admin_all_filter: 'All',
  admin_incoming_messages: 'Incoming contact messages will appear here.',
  admin_no_new_messages: 'No new messages.',
  admin_activity_messages: 'Contact Message',
  admin_activity_quotes: 'Quote Request',
  admin_activity_appointments: 'Appointment',
  admin_activity_ai_leads: 'AI Lead',
  admin_activity_empty: 'No recent activity',
  admin_loading_dashboard: 'Loading dashboard...',
  admin_dashboard_refresh: 'Refresh Dashboard',
  admin_email_note: 'This would open your default email client.',
  admin_whatsapp_body: 'Open WhatsApp chat with',
  admin_whatsapp_note: 'Phone:',
  admin_marked_contacted: 'marked as contacted',
  admin_marked_resolved: 'marked as resolved',
  admin_no_resolved_messages: 'No resolved messages.',
  admin_ok: 'OK',
  admin_enter_title: 'Enter slide title',
  admin_enter_desc: 'Enter slide description',
  admin_enter_service_name: 'Enter service name',
  admin_enter_short_desc: 'Brief description for cards',
  admin_enter_full_desc: 'Detailed description for service detail page',
  admin_image_example: 'e.g., Living Room Deep Clean',
  admin_alt_placeholder: 'Descriptive text for accessibility',
  admin_placeholder_city: 'e.g., Santa Rosa',
  admin_placeholder_facebook: 'https://facebook.com/yourpage',
  admin_placeholder_hero_cta: 'Get Your Free Quote',
  admin_placeholder_about_title: 'About Us',
  admin_placeholder_about_text: 'Describe your business...',
  admin_placeholder_footer_text: 'Your footer tagline...',
  admin_placeholder_company: 'Your company name',
  admin_placeholder_phone: '(555) 000-0000',
  admin_placeholder_email: 'contact@company.com',
  admin_placeholder_address: 'City, State',
  admin_placeholder_fb_url: 'https://facebook.com/yourpage',
  admin_placeholder_ig_url: 'https://instagram.com/yourhandle',
  admin_placeholder_yelp_url: 'https://yelp.com/biz/your-business',
  admin_placeholder_weekday: 'Mon–Fri: 8:00 AM – 6:00 PM',
  admin_placeholder_weekend: 'Sat–Sun: 9:00 AM – 4:00 PM',
  admin_embed_placeholder: 'Paste your Facebook embed code here...',
  admin_tag_placeholder: 'PROFESSIONAL SERVICE',
  admin_category_house_cleaning: 'House Cleaning',
  admin_category_apartment_cleaning: 'Apartment Cleaning',
  admin_category_office_cleaning: 'Office Cleaning',
  admin_category_post_construction: 'Post-Construction',
  admin_category_move_in_out: 'Move-In / Move-Out',
  admin_placeholder_city_name: 'e.g., Santa Rosa',
  admin_placeholder_state: 'CA',

  // Admin Login
  admin_login_title: 'Admin Login',
  admin_login_email: 'Email',
  admin_login_email_placeholder: 'admin@company.com',
  admin_login_password: 'Password',
  admin_login_password_placeholder: 'Enter your password',
  admin_login_show_password: 'Show password',
  admin_login_hide_password: 'Hide password',
  admin_login_captcha: 'Security Check',
  admin_login_captcha_question: 'What is {{a}} + {{b}}?',
  admin_login_captcha_error: 'Incorrect answer. Please try again.',
  admin_login_slider_hint: 'Slide to verify',
  admin_login_slider_success: 'Verified',
  admin_login_slider_error: 'Try again',
  admin_login_submit: 'Sign In',
  admin_login_loading: 'Signing in...',
  admin_login_invalid: 'Invalid email or password.',
  admin_login_error: 'Login failed. Please try again.',
  admin_login_access_denied: 'Access Denied',
  admin_login_access_denied_msg: 'You must be logged in to access the admin panel.',
  admin_logout: 'Logout',
  admin_logout_confirm: 'Are you sure you want to log out?',
  admin_logout_success: 'Logged out successfully.',
  admin_back_to_site: 'Back to Website',
  admin_change_password: 'Change Password',
  admin_current_password: 'Current password',
  admin_new_password: 'New password',
  admin_confirm_password: 'Confirm new password',
  admin_password_min_error: 'Password must be at least 8 characters.',
  admin_password_match_error: 'Passwords do not match.',
  admin_password_required: 'Please fill in all password fields.',
  admin_password_update: 'Update Password',
  admin_password_endpoint_error: 'Password update endpoint is not available yet.',
  admin_password_success: 'Password updated successfully.',
  admin_api_error: 'API error. Please try again.',
  admin_api_saved: 'Saved successfully.',
  admin_api_deleted: 'Deleted successfully.',
  admin_loading_data: 'Loading...',
  admin_add_success: 'Added successfully.',
  admin_upload_success: 'Image uploaded successfully.',
  admin_upload_error: 'Image upload failed. Please try again.',
  admin_error: 'Error',
  admin_load_error: 'Failed to load settings. Please try again.',
  admin_save_error: 'Failed to save settings. Please try again.',
  admin_email_body: 'Send an email to',

  admin_form_title: 'Title',
  admin_form_subtitle: 'Subtitle',
  admin_form_description: 'Description',
  admin_form_image: 'Image',
  admin_form_upload: 'Upload Image',
  admin_form_order: 'Order',
  admin_form_active: 'Active',
  admin_form_save: 'Save',
  admin_form_cancel: 'Cancel',
  admin_form_edit: 'Edit',
  admin_form_delete: 'Delete',
  admin_form_view: 'View',
  admin_form_mark_contacted: 'Mark as Contacted',
  admin_toggle_menu: 'Toggle menu',
  admin_prev_slide: 'Previous slide',
  admin_next_slide: 'Next slide',
  admin_go_slide: 'Go to slide',
  admin_close_lightbox: 'Close lightbox',
  admin_prev_image: 'Previous image',
  admin_next_image: 'Next image',
  service_recurring_contract: 'Recurring Contract',
  service_one_time_cleaning: 'One-Time Cleaning',
  service_deep_cleaning: 'Deep Cleaning',
  service_regular_cleaning: 'Regular Cleaning',
  service_light_cleaning: 'Light Cleaning',
  service_airbnb_cabin: 'Airbnb Cabin Cleaning',
};

export default homeTranslations;